let React = require("react");

const {  Link  } = require('react-router-dom');

let SiteHeader =         require("../controls/SiteHeader.jsx");
let Footer =             require("../controls/Footer.jsx");

class Updates extends React.Component {

    constructor() {
        super();

        this.onSearch = this.onSearch.bind(this);
    }

    componentDidMount() {
        document.title = "What's New | library.io";
        googleGA("send", "event", "updates", "pageview");
    }

    onSearch(value){
        this.props.history.push(`/search?q=${value}`);
    }

    render() {
        return (
            <div>
                <SiteHeader type="Explore" onSearch={this.onSearch}/>
                <section className="cover">
                    <div className="container">
                        <h1>What's New</h1>
                        <p>Find out about the latest updates and improvements to library.io</p>
                    </div>
                </section>
                <section>
                    <div className="container update-container">
                        <div className="date">June 8th, 2026</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">Library.io continues after EAGLE support ends</h2>
                                <p>
                                    Library.io remains fully functional after Autodesk EAGLE support ends. Continue using library.io with Autodesk Fusion to build your next PCB.
                                </p>
                                <br/>
                                <p>
                                    <a href="https://www.autodesk.com/products/fusion-360/overview" className="button" target="_blank">Continue with Autodesk Fusion</a>
                                </p>
                            </div>
                            <div className="notes">
                                <div className="notes__title">Resources</div>
                                <ul>
                                    <li><a href="https://www.autodesk.com/products/fusion-360/blog/eagle-to-autodesk-fusion-transition/" target="_blank">Expanded electronics design capabilities in Fusion</a></li>
                                    <li><a href="https://www.autodesk.com/support/technical/article/caas/sfdcarticles/sfdcarticles/How-to-migrate-from-EAGLE-Schematics-PCBs-Libraries-to-Autodesk-Fusion-Electronics.html" target="_blank">How to migrate from EAGLE to Fusion</a></li>
                                </ul>
                            </div>
                        </div>

                    </div>{/* End June 8th, 2026 release notes*/ }

                <div className="container update-container">
                        <div className="date">November 10th, 2020</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">Thumbnail and Search Improvements</h2>
                                <p>Improved the reliability of thumbnail generation, especially for Packages.<br/>
                                Special characters are now handled when searching.<br/>
                                
                                
                                </p><br/>

                            </div>

                            <div className="notes">
                                <div className="notes__title">Bug fixes and enhancements</div>
                                    <ul>
                                    <li><span className="subheading">Search</span>
                                        <ul>
                                            <li>Searching on explore resets to first page.</li>
                                            <li>New Fusion IPC types added.</li>
                                            <li>Removed initial filter from Explore: Packages.</li>
                                        </ul> <br/>
                                    </li>
                                    </ul>
                            </div>
                        </div>

                    </div>{/* End March 10th, 2020 release notes*/ }
                <div className="container update-container">
                        <div className="date">March 10th, 2020</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">Fusion Compatability</h2>
                                <p>F3D Files are now accepted as a source for 3D models.<br/>
                                Premium accounts can now export all content as F3D.<br/>
                                
                                
                                </p><br/>

                            </div>

                            <div className="notes">
                                <div className="notes__title">Bug fixes and enhancements</div>
                                    <ul>
                                    <li><span className="subheading">General</span>
                                        <ul>
                                            <li>New Units added to align with Fusion.</li>
                                            <li>Improved reliability when uploading multiple models at once.</li>
                                            <li>Improved thumbnail reliability.</li>
                                        </ul> <br/>
                                    </li>
                                    </ul>
                            </div>
                        </div>

                    </div>{/* End March 10th, 2020 release notes*/ }
                <div className="container update-container">
                        <div className="date">August 29th, 2019</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">{fullHubAlias}s</h2>
                                <p>All Managed Libraries, Packages, and 3D Models now reside within a {fullHubAlias}.
                                The owner of a {fullHubAlias} can invite members to create and edit data in the {hubAlias}.

                                Free users are limited to one {hubAlias}.
                                Standard and Premium users can create up to 16 different {hubAlias}s.</p><br/>

                                <h2 className="headline">Creating and Deleting {hubAlias}s</h2>
                                <p>Standard and Premium users can create and delete {fullHubAlias}s in the Library.io Dashboard.  The owner of a {hubAlias} can also transfer ownership of the {hubAlias} to one of its members.</p><br/>

                                <h2 className="headline">Copying Assets</h2>
                                <p>Assets can only reference content within the same {hubAlias},
                                so if you copy-paste an asset to a Library of a different {hubAlias},
                                a fresh copy will be created in the destination {hubAlias}.
                                There is also a new option in Library.io to copy public Packages into one of your {hubAlias}s.
                                 </p>


                            </div>

                            <div className="notes">
                                <div className="notes__title">Bug fixes and enhancements</div>
                                    <ul>
                                    <li><span className="subheading">Package Editor Improvements</span>
                                        <ul>
                                            <li>Copy public assets into a {fullHubAlias} of your choice.</li>
                                            <li>Entirely remove a 3D model (including the box) from a package.</li>
                                            <li>More viewing options.</li>
                                        </ul> <br/>
                                    </li>
                                    <li><span className="subheading">Website Improvements</span>
                                        <ul>
                                            <li>Improved handling of error messages across the site.</li>
                                            <li>Asynchronous 3D model uploading.</li>
                                            <li>Assets' status now displayed in trash.</li>
                                            <li>New status for when a new version fails to upload.</li>
                                        </ul> <br/>
                                    </li>
                                    <li><span className="subheading">Generator Bug Fixes</span>
                                        <ul>
                                            <li>Names for SMD packages now include density.</li>
                                            <li>Corrected terminal in Crystal SMD model.</li>
                                            <li>Crystal SMD image now includes height dimension with terminal.</li>
                                            <li>Convex Chip Array terminal shape and image fixes.</li>
                                        </ul> <br/>
                                    </li>
                                    </ul>
                            </div>
                        </div>

                    </div>{/* End August 20th, 2019 release notes*/ }
                <div className="container update-container">
                        <div className="date">February 21st, 2019</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">Package Editor Stability and Performance Improvements</h2>
                                <p>To improve the reliability of the package editor, incremental edits to packages are no longer persisted. To save changes, create a new version of the package.</p><br />
                            </div>

                            <div className="notes">
                            </div>
                        </div>
                    </div>{/* End February 21st, 2019 release notes*/ }
                <div className="container update-container">
                        <div className="date">January 11th, 2019</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">Generate Additional Package Types</h2>
                                <p>Added the ability to generate SON packages, through-hole crystals, and radial round capacitors, inductors, and LEDs.</p><br />
                                <h2 className="headline">Generate SOIC Thermal Pads</h2>
                                <p>Added the ability to generate thermal pads and custom solder paste for SOIC packages.</p><br />
                            </div>

                            <div className="notes">
                                <div className="notes__title">Bug fixes and enhancements</div>
                                    <ul>
                                        <li>Now correctly generating flat terminals for chip array packages.</li>
                                        <li>Now showing only applicable family types for DFN-2/3/4 packages.</li>
                                        <li>Fixed 3D model output when specifying only two of D, D2, and L parameters for ECAP and crystal generators.</li>
                                        <li>Now using custom color for capacitors when generating chip array packages.</li>
                                    </ul>
                                </div>
                            </div>
                    </div>{/* End January 11th, 2019 release notes*/ }
                <div className="container update-container">
                        <div className="date">October 24th, 2018</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">Delete and Undelete Libraries, Packages, and 3D Models</h2>
                                <p>Deleted assets can be viewed and restored from the <Link to={{pathname: "/start", state: {tab: "trash"}}}>trash tab</Link> in your dashboard on library.io. Deleted assets will not appear for download inside of EAGLE.</p><br />
                            </div>

                            <div className="notes">
                                <div className="notes__title">Bug fixes and enhancements</div>
                                    <ul>
                                    <li>New 2D/3D switcher allows toggling between the footprint and 3D model thumbnails of packages on library.io.</li>
                                    </ul>
                                </div>
                            </div>
                    </div>{/* End October 24th, 2018 release notes*/ }
                <div className="container update-container">
                        <div className="date">September 27th, 2018</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">Generate New Packages from Existing Ones</h2>
                                <p>Added the ability to view the parameters used to generate a package and the ability to create a new package starting from those parameters.</p><br />
                                <h2 className="headline">Generate QFN and QFP Thermal Pads</h2>
                                <p>Thermal pads can now be generated for QFN and QFP packages (both footprints and 3D models), including custom solder paste.</p><br />
                            </div>

                            <div className="notes">
                                <div className="notes__title">Bug fixes and enhancements</div>
                                    <ul>
                                    <li><span className="subheading">Improvements to Package Generator Output</span>
                                        <ul>
                                            <li>Pad roundness values in package generator now match those in EAGLE and are no longer capped.</li>
                                            <li>Header packages can now be generated with their origin at the center of their pads (or at pin 1, as previously).</li>
                                            <li>Swapped the D and E (length and width) parameters for PLCC package generation to align with other packages and IPC standard.</li>
                                            <li>Now including polarity bands on generated 3D models for SOD, SODFL, and polarized molded body packages.</li>
                                        </ul>
                                    </li>
                                    <li><span className="subheading">Improvements to Package Generator UI</span>
                                        <ul>
                                            <li>Model generator is now correctly cancelled if an existing 3D model or STEP file is added to the package or on removal of the custom model.</li>
                                            <li>Model generator can now only be used for imported (not generated) packages.</li>
                                        </ul>
                                    </li>
                                    <li><span className="subheading">3D Footprint Geometry Export</span>
                                        <ul>
                                            <li>3D footprint geometry can now be exported as an OBJ for reference in creating a 3D model for a package (e.g. in Fusion or TinkerCAD).</li>
                                        </ul>
                                    </li>
                                    <li><span className="subheading">Miscellaneous</span>
                                        <ul>
                                            <li>3D boxes now default to partial transparency to improve visibility of footprints.</li>
                                            <li>Suggested models tab has been removed from the package editor.</li>
                                            <li>No longer showing a warning when using the library.io editors from browsers other than Chrome.</li>
                                        </ul>
                                    </li>
                                    </ul>
                                </div>
                            </div>
                    </div>{/* End September 27th, 2018 release notes*/ }
                <div className="container update-container">
                        <div className="date">August 14th, 2018</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">Website Updates</h2>
                                <p>Progress of library imports and metadata for public packages.</p><br />
                            </div>

                            <div className="notes">
                                <div className="notes__title">Bug fixes and enhancements</div>
                                    <ul>
                                        <li>The progress of managed library imports is now shown on library.io, including those initiated from EAGLE.</li>
                                        <li>Metadata (e.g. pins, pitch, body size) for public packages can now be viewed and used as search filters on the explore pages.</li>
                                        <li>Added link to 3D model details page from details page of packages with 3D models.</li>
                                    </ul>
                                </div>
                            </div>
                    </div>{/* End August 14th release notes*/ }
                <div className="container update-container">
                        <div className="date">July 25th, 2018</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">Import Altium and OrCAD Libraries</h2>
                                <p>Translate Altium&reg; and OrCAD&reg; libraries to EAGLE format by uploading them on the library.io website.</p><br />

                                <h2 className="headline">Explore Public Libraries, Packages, and 3D Models</h2>
                                <p>The new explore pages allow browsing and downloading of shared content from Autodesk and select partners on the library.io website.</p><br />

                                <h2 className="headline">Generate Footprints and 3D Models for Pin Headers</h2>
                                <p>The package generator now supports creation of male and female headers.</p><br />

                                <h2 className="headline">Generate 3D Models for Existing Footprints</h2>
                                <p>Use the package editor in EAGLE or on the library.io website to generate 3D models for existing footprints in your managed libraries.</p>
                            </div>

                            <div className="notes">
                                <div className="notes__title">Bug fixes and enhancements</div>
                                    <ul>
                                        <li>Improvements to the reliability of the generation of thumbnails for 3D packages.</li>
                                        <li>Improvements to the reliability of the importing of STEP files.</li>
                                        <li>Support for the creation of larger managed libraries.</li>
                                        <li>Support creation of new versions of managed libraries by uploading unmanaged EAGLE library files using the library.io website.</li>
                                        <li>Now ensure that assets added to public libraries are made public.</li>
                                        <li>Now showing asset summaries, not descriptions, in list views.</li>
                                    </ul>
                                </div>
                            </div>
                    </div>{/* End July 25th release notes*/ }
                <div className="container update-container">
                        <div className="date">June 8th, 2018</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">Added Pad-to-Hole input to Package Generators</h2>
                                <p>Added pad-to-hole ratio to through-hole package generators to allow specifying of pad diameter relative to hole diameter.</p><br/>

                                <h2 className="headline">Library, Package, and 3D Model Previews</h2>
                                <p>Added previews of libraries, packages, and 3D models to the website. This includes a permanent URL (permalink) for each asset.</p>
                            </div>

                            <div className="notes">
                                <div className="notes__title">Bug fixes and enhancements</div>
                                    <ul>
                                        <li>Fixed searching for 3D models.</li>
                                    </ul>
                                </div>
                            </div>
                    </div>{/* End June 8th release notes*/ }
                    <div className="container update-container">
                        <div className="date">May 14th, 2018</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">Through-Hole Package Generators</h2>
                                <p>The Package Generator now supports the creation of IPC-compliant 2D footprints and 3D models for axial and dual-in-line (DIP) packages.</p>                            </div>

                            <div className="notes">
                                <div className="notes__title">Bug fixes and enhancements</div>
                                    <ul>
                                    <li><span className="subheading">Improvements to Package Generator UI</span>
                                        <ul>
                                            <li>The default unit can now be changed inside the options window.</li>
                                            <li>Unit labels have moved inside text input fields to make clearer that users can enter units other than the default unit.</li>
                                            <li>Hotkey for select all now works within text input fields.</li>
                                        </ul>
                                    </li>
                                    <li><span className="subheading">Improvements to Package Rendering</span>
                                        <ul>
                                            <li>Properties (e.g. >NAME and >VALUE) are now rendered in the package editor.</li>
                                            <li>Documentation/assembly geometry (the EAGLE tDocu/bDocu layers) is now rendered in the package editor.</li>
                                        </ul>
                                    </li>
                                    <li><span className="subheading">Improvements to the Package Generator Output</span>
                                        <ul>
                                            <li>Footprint property texts (name and value) are now centered at origin along x-axis.</li>
                                            <li>Increased pin 1 marker dot silkscreen size.</li>
                                            <li>Thermal flag is now set for pads in generated footprints.</li>
                                            <li>MELF diodes are now generated with an appropriate package color.</li>
                                            <li>Fixed a rounding issue that would occasionally lead to an incorrect trailing digit in the numerical portions of the generated IPC package names.</li>
                                        </ul>
                                    </li>
                                    <li><span className="subheading">Error Handling</span>
                                        <ul>
                                            <li>Corrupt / invalid 3D model (STEP) files can no longer be added to a 3D package.</li>
                                            <li>Error messages have been improved.  Error messages now show the id of the logged in user, the id of the asset being edited, what the user was attempting to do at the time of the error, details about what went wrong, and a link to Autodesk support.</li>
                                            <li>Fixed a bug in the package editor that prevented users from uploading the same step file twice in a row.</li>
                                        </ul>
                                    </li>

                                    </ul>
                                </div>
                            </div>
                    </div>{/* End May 14th release notes*/ }

                    <div className="container update-container">
                        <div className="date">March 27th, 2018</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">User dashboard search</h2>
                                <p>Added search capabilities to the user dashboard.  Advance filters can be applied to packages.</p>
                            </div>

                            <div className="notes">
                                <div className="notes__title">Bug fixes and enhancements</div>
                                    <ul>
                                        <li><span className="subheading">Improvements to Package Generator UI</span>
                                            <ul>
                                                <li>Min and max input fields are placed in a single row for Package Generator parameters.</li>
                                                <li>The dimensioned package image is always visible when scrolling through the input form.</li>
                                                <li>The camera position is preserved when updating the preview, making it easier to compare packages before and after changes.</li>
                                            </ul>
                                        </li>
                                        <li><span className="subheading">Improvements to the Package Generator output</span>
                                            <ul>
                                                <li>The Package Generator now uses alphanumeric pin numbering for BGA packages.</li>
                                                <li>Generated silkscreen is now correctly mapped to the package body for DFN-2/3/4 and MELF packages.</li>
                                                <li>The redundant pin 1 marker was removed from the silkscreen for generated molded body packages.</li>
                                                <li>Fixed clearance of pin 1 marker from other silkscreen.</li>
                                            </ul>
                                        </li>
                                        <li>Fixed scroll to zoom in Firefox.</li>
                                        <li>Fixed an issue that caused sporadic unauthorized errors to appear in package editor.</li>
                                        <li>Fixed an issue that caused Safari to download exported 3D package library files with the "xml" extension instead of "lbr."</li>
                                        <li>Now showing a loading screen while exporting a 3D package library file.</li>
                                        <li>Search results now show asset summaries, not descriptions.</li>
                                        <li>Fixed an issue that slowed loading of the Package Generator, search, and editor web pages.</li>
                                    </ul>
                                </div>
                            </div>
                    </div>{/* End March 27th release notes*/ }

                    <div className="container update-container">
                        <div className="date">March 8th, 2018</div>
                        <hr/>
                        <div className="update__item">
                            <div className="headline">
                                <h2 className="headline">Initial Release</h2>
                                <p>Create manufacturing-ready footprints & 3D models.  Instantly generate PCB packages by entering a few dimensions from a data sheet.</p>
                                <div className="blog__link">
                                    <a href="https://forums.autodesk.com/t5/eagle-forum/eagle-8-7-parametric-2d-amp-3d-model-generation-library-io-more/td-p/7836642" target="_blank">Read More ></a>
                                </div>
                            </div>
                            <div className="notes">
                            </div>
                        </div>
                    </div>{/* End March 8th release notes*/ }


                </section>

                <Footer/>
            </div>
        );
    }
}

module.exports = Updates;
